module.exports = __webpack_public_path__ + "static/media/imagen_ubicacion.fb6e3de3.png";